import type { RemoteErrorStatus } from "./remoteCollectionState";
import { getRemoteErrorStatus } from "./remoteCollectionState";

export type RemoteEntityState<T> =
    | { status: "loading" }
    | { status: "success-value"; entity: T; refreshError?: RemoteErrorStatus }
    | { status: RemoteErrorStatus };

type RemoteEntityStateInput<T> = {
    entity: T | undefined;
    entityId: string | number | undefined;
    error: unknown;
    isLoading: boolean;
};

/** Classifies one remote entity without turning unresolved or failed data into an empty value. */
export const getRemoteEntityState = <T>({
    entity,
    entityId,
    error,
    isLoading,
}: RemoteEntityStateInput<T>): RemoteEntityState<T> => {
    if (entityId === undefined) return { status: "not-found" };
    if (entity !== undefined) {
        return error === null || error === undefined ?
                { status: "success-value", entity }
            :   { status: "success-value", entity, refreshError: getRemoteErrorStatus(error) };
    }
    if (error !== null && error !== undefined) return { status: getRemoteErrorStatus(error) };
    if (isLoading) return { status: "loading" };

    return { status: "not-found" };
};
